import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ADVICE from '../../constants/ADVICE'

const AdviceBox = ({ category }) => {
    const { [category]: listOfAdvice } = ADVICE
    const adviceCount = listOfAdvice.length - 1

    const [currentAdviceIndex, setCurrentAdviceIndex] = useState(
        Math.floor(Math.random() * adviceCount)
    )

    const [currentAdviceText, setCurrentAdviceText] = useState(
        listOfAdvice[currentAdviceIndex]
    )

    const increaseAdviceIndex = () => {
        const index = (currentAdviceIndex + 1) > adviceCount
            ? 0
            : currentAdviceIndex + 1
        const text = listOfAdvice[index]
        setCurrentAdviceIndex(index)
        setCurrentAdviceText(text)
    }

    return (
        <div className="result__tips">
            <h3>Tip:</h3>
            {currentAdviceText}
            <div className="result__tips--paging">
                <button type="button" className="result__tips--next" onClick={() => increaseAdviceIndex()}>
                    next
                </button>
                <span className="result__tips--counter">
                    {` ${currentAdviceIndex + 1}/${adviceCount + 1}`}
                </span>
            </div>
        </div>
    )
}

AdviceBox.propTypes = {
    category: PropTypes.string.isRequired,
}

export default AdviceBox
